import React, { useEffect, useState, useContext } from "react";
import { useHistory, generatePath } from 'react-router-dom'
import { alpha, makeStyles, AppBar, Button, Grid, TextField, Typography, Hidden, InputAdornment, IconButton, Toolbar, Box, Paper, Divider, Tooltip } from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from "@material-ui/icons/Clear";
import AppConstants from "../../../common/AppConstants";
import { CurriculumDataService } from '../../../services/index'
import RouteConstants from "../../../common/RouteConstants";
import PageNotFoundUI from "../../../sharedComponents/emptyStateUIContainers/PageNotFoundUI";

import PublicCurriculumCard from "./PublicCurriculumCard";
import SectionLoader from "../../../sharedComponents/Loader/SectionLoader";
import Pagination from "../../../sharedComponents/Pagination/Pagination";

const useStyles = makeStyles((theme) => ({
    subHeader: {
        background: '#fff',
    },
    subHeaderTitle: {
        fontWeight: '600',
        flex: '1',
    },
    titleHeader: {
        fontWeight: '600',
    },
    cardbox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        border: '1px solid #b3b3b3',
        boxShadow: '0px 0px 1px 0px #b3b3b3',
        '& .MuiCardHeader-root': {
            padding: theme.spacing(.5, 2, 0),
            '& .MuiCardHeader-action': {
                marginTop: '0',
                marginRight: '0',
            },
        },
        '& .MuiCardContent-root': {
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(.75) + "px !important",
            // height: '100%',
        },
        '& .MuiCardActions-root': {
            justifyContent: 'flex-end',
            '& .MuiButton-root': {
                background: '#000',
                color: '#fff',
                textTransform: 'unset',
                borderRadius: '50px',
                '& .MuiButton-label': {
                    '& .MuiSvgIcon-root': {
                        color: '#fff',
                    },
                },
            },
        },
    },
    cardFooterText: {
        fontSize: '0.65rem',
        lineHeight: '1',
        fontWeight: '500',
    },
    starterColor: {
        color: '#2c8416',
    },
    intermediateColor: {
        color: '#ff7e06',
    },
    expertColor: {
        color: '#c91020',
    },
    iconFontSize: {
        fontSize: '1rem',
    },
    Pagination: {
        '& > div': {
            marginLeft: theme.spacing(1),
            [theme.breakpoints.down("xs")]: {
                marginLeft: theme.spacing(0),
            },
            '& > svg': {
                color: '#ffffff',
            },
            '& > div': {
                backgroundColor: '#1d428a !important',
                borderRadius: '4px !important',
                color: '#ffffff',
            },
        },
    },
}));

const PublicCurriculumContainer = () => {
    const history = useHistory()
    const classes = useStyles();
    const [filter, setFilter] = useState({
        curriculumBadge: [0],
        curriculumLevel: [0],
        curriculumStatus: [-1],
        curriculumAccess: [],
        pageIndex: 1,
        recordCount: 0,
        pageSize: 12

    })
    const [loading, setLoading] = useState(true)
    const [filterText, setFilterText] = useState('')
    const [filterCurriculum, setFilterCurriculum] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        getCurriculumData()
    }, [filter])

    const getCurriculumData = () => {
        setLoading(true);
        let _payload = {
            filterText: filterText,
            pageIndex: filter.pageIndex,
            pageSize: filter.pageSize,

        }
        CurriculumDataService.getPublicCurriculums(_payload)
            .then(res => {
                setFilterCurriculum(res.data)
                setTotalRecords(res.totalRecordCount)
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                setLoading(false)
            })
    }


    const handleCurriculumStart = (curriculumID) => {
        setLoading(true);
        console.log("Curriculum started " + curriculumID); 
        history.push(generatePath(RouteConstants.CURRICULUM_CONTENT, { id: curriculumID }))
        setLoading(false);
    }

    const handlePageSizeChange = (size) => {
        setFilterCurriculum([]);
        setFilter({ ...filter, pageSize: size, pageIndex: 1, recordCount: 0 })
    }

    const onPageNoChange = (pageNo) => {
        setFilterCurriculum([]);
        setFilter( { ...filter, pageIndex : pageNo})
    }

    const handleOnKeyUp = (event) => {
        if (event.keyCode === 13) {
            handleSearch();
        }
    }
    const handleSearch = () =>{
        setFilter( { ...filter, pageIndex : 1})
    }

    const handleClearText = () => {
        setFilterText('');
        handleSearch();
    }

    return (
        <>
            <AppBar position="static" className={classes.subHeader}>
                <Toolbar variant="dense">
                    <Typography variant="body2" className={classes.subHeaderTitle} color="secondary">
                        List of Curriculums
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box style={{ padding: '16px' }}>
                <Paper>
                    <Box component="div" display="flex" alignItems="center" paddingX={2} paddingY={1}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs={2} sm={2} md={2}>
                                <Typography variant="body2" color="primary" className={classes.titleHeader}>{`Total Curriculums: ${totalRecords}`}</Typography>
                            </Grid>                           
                            <Grid item xs={2} sm={2} md={2}>
                                <div className={classes.search}>
                                    <TextField size="small"
                                        fullWidth
                                        value={filterText}
                                        onKeyUp={(event) => handleOnKeyUp(event)}
                                        onChange={e =>setFilterText(e.target.value)}
                                        variant="outlined"
                                        id="search"
                                        placeholder="Search…"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {filterText != "" && (
                                                        <>
                                                            <ClearIcon
                                                                fontSize="small"
                                                                onClick={handleClearText}
                                                                style={{ cursor: "pointer" }}
                                                            ></ClearIcon>
                                                            <SearchIcon 
                                                            onClick={e => handleSearch()}                                                                
                                                                style={{ cursor: "pointer" }}
                                                                size="small"
                                                            ></SearchIcon>
                                                        </>
                                                    )}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider style={{ width: '100%' }} />
                    <Box component="div" display="flex" alignItems="center" padding={2} style={{ display: 'flex', alignItems: 'center', padding: '12px', }}>
                        {loading ? <SectionLoader /> :
                            <Grid container alignItems="center" spacing={2}>
                                {filterCurriculum && filterCurriculum.length > 0 ? <>
                                    {filterCurriculum.length > 0 && filterCurriculum.map((option, i) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={i}>
                                            { 
                                                option && option.curriculumStatus == 1 && 
                                                <PublicCurriculumCard option={option} 
                                                handleCurriculumStart={handleCurriculumStart} 
                                                key={option.curriculumID} />
                                            }
                                        </Grid>
                                    ))}

                                    {filterCurriculum && filterCurriculum.length > 0 &&
                                        <Grid item xs={12} sm={12} md={12}>
                                            <Box display="flex" alignItems="center" justifyContent="center">
                                                <Hidden xsDown>
                                                    <label>Page Size</label>
                                                </Hidden>
                                                <TextField
                                                    id="outlined-select-currency"
                                                    select
                                                    value={String(filter.pageSize)}
                                                    onChange={(event) => handlePageSizeChange(parseInt(event.target.value))}
                                                    variant="outlined"
                                                    size="small"
                                                    className={classes.Pagination}
                                                >
                                                    {AppConstants.PAGE_SIZES.map((option) => (
                                                        <MenuItem key={option} value={option} className="MenuItem">
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                                <Pagination
                                                    pageSize={filter.pageSize}
                                                    totalProfile={totalRecords}
                                                    changePageNumber={(e) => {
                                                        onPageNoChange(e.selected + 1);
                                                    }}
                                                    currentPageNo={filter.pageIndex}
                                                />
                                            </Box>
                                        </Grid>
                                    }
                                </>
                                    : <PageNotFoundUI title="Data not found" subtitle=" " />}
                            </Grid>}
                    </Box>
                </Paper>
                {/* <Loader isLoading={loading} /> */}
            </Box>
        </>

    )
}


export default PublicCurriculumContainer;
